import { Alert, AlertTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

type SignupServerErrorSummaryProps = {
  serverErrors: string[];
};

export const SignupServerErrorSummary = (props: SignupServerErrorSummaryProps) => {
  const { serverErrors } = props;
  const { t } = useTranslation(['common']);
  if (serverErrors.length > 0) {
    return (
      <Alert severity='error' variant='filled' sx={{ borderRadius: 0, mt: -2, mr: -2, ml: -2, mb: 2 }}>
        <AlertTitle sx={{ fontSize: '1.2rem' }}>{t('common:signup.errorSummaryHeader')}</AlertTitle>
        <ul style={{ margin: 0, paddingLeft: 0 }}>
          {serverErrors.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </Alert>
    );
  }
  return null;
};
